import axios from 'axios'

const fetchById =  async function(id){
    try{
        const   path = `/hr_indicator/${id}`
            ,   route = process.env.VUE_APP_API_ROUTE.concat( path )
            ,   response = await axios.get(route)
        return response.data
    }
    catch( error ) {
        return error.response.data
    }
}

export default fetchById
